var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommoditiesInjection = function SvgCommoditiesInjection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.114 10.504a.18.18 0 0 1 .181.146l.161.942a7.102 7.102 0 0 0-.647 4.671H2.185A.18.18 0 0 1 2 16.09c0-.01 0-.02.002-.029l.923-5.41a.18.18 0 0 1 .182-.146h6.007Zm5.932-2.727-.79-4.63A.18.18 0 0 0 14.074 3H8.067a.18.18 0 0 0-.181.146l-.924 5.41c-.002.009-.002.02-.002.028a.18.18 0 0 0 .184.175h4.973a7.123 7.123 0 0 1 2.929-.982Z",
    fill: "#D1B896"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62 14.842c0 3.401 2.77 6.158 6.19 6.158 3.418 0 6.19-2.757 6.19-6.158 0-3.4-2.772-6.158-6.19-6.158-3.42 0-6.191 2.757-6.191 6.158Zm8.994-.172a.46.46 0 0 1 .045.6l-.045.053-2.477 2.463a.466.466 0 0 1-.604.045l-.052-.045-2.476-2.464a.46.46 0 0 1 0-.653.466.466 0 0 1 .604-.045l.052.045 1.685 1.676v-4.12c0-.234.174-.427.4-.458l.064-.004c.235 0 .43.174.46.399l.004.063v4.12l1.684-1.675a.466.466 0 0 1 .604-.045l.052.045Z",
    fill: "#2F5EA7"
  })));
};
export default SvgCommoditiesInjection;